module.exports = __webpack_public_path__ + "static/banner-mobile-2b4d6e474ad3d072dc5a312dc1efe950.jpg";